import type { ProjectProduct } from '@/api/generated/model/projectProduct';
import { DollarSign, GraduationCap, MessageSquare, Smile, Users, type LucideIcon } from 'lucide-react';

export type ProjectProductFeature = {
  label: string;
  icon: LucideIcon;
};

export type ProjectProductConfig = {
  value: ProjectProduct;
  title: string;
  description: string;
  features: ProjectProductFeature[];
  icon: LucideIcon;
};

/** Icons mirror the subproduct icons used in the app shell left rail. */
const EXPERIENCE_FEATURE: ProjectProductFeature = { label: 'Experience', icon: Smile };
const PROFICIENCY_FEATURE: ProjectProductFeature = { label: 'Proficiency', icon: GraduationCap };
const ROI_FEATURE: ProjectProductFeature = { label: 'ROI', icon: DollarSign };

export const PROJECT_PRODUCT_CONFIG: Record<ProjectProduct, ProjectProductConfig> = {
  internal: {
    value: 'internal',
    title: 'Employee Agent',
    description: 'Your own people using AI at work — internal assistants, copilots and agents.',
    features: [EXPERIENCE_FEATURE, ROI_FEATURE, PROFICIENCY_FEATURE],
    icon: Users,
  },
  external: {
    value: 'external',
    title: 'Customer Agent',
    description: 'Your customers talking to an AI you ship — support bots and in-product assistants.',
    features: [EXPERIENCE_FEATURE],
    icon: MessageSquare,
  },
};

export const PROJECT_PRODUCT_OPTIONS = Object.values(PROJECT_PRODUCT_CONFIG);

export function getProjectProductConfig(product: ProjectProduct | undefined): ProjectProductConfig {
  return PROJECT_PRODUCT_CONFIG[product ?? 'external'];
}

export const DEFAULT_CREATE_PROJECT_PRODUCT: ProjectProduct = 'internal';
